import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import {UtilsService} from '../services/utils.service';
import {TranslateService} from '@ngx-translate/core';
import { Subject } from 'rxjs/Subject';
import {LoginService} from '../services/login.service';
import {GoogleAnalyticsService} from "../services/google-analytics-service";

export interface UnsubscribePaymentModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-unsubscribe-payment-modal',
  templateUrl: './unsubscribe-payment-modal.component.html',
  styleUrls: ['./unsubscribe-payment-modal.component.css']
})
export class UnsubscribePaymentModalComponent extends DialogComponent<UnsubscribePaymentModalModel, boolean> implements OnInit {
  title: string;
  data: any;
  unsubType: string = ''

  constructor(dialogService: DialogService, private utilsService: UtilsService, private translate: TranslateService, private loginService: LoginService, private ga: GoogleAnalyticsService) {
    super(dialogService);
  }

  ngOnInit() {
    document.getElementsByTagName('body')[0].classList.add('modal-open');
  }
  
  ok() {
  	
    this.close();
  }

  cancel() {
  	  this.result = true;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/unsubscribe-payment-modal.component.ts